import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Instagram = ({ color = '#8BD2D7', ...rest }: Props) => {
  return (
    <Svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M24.75 0H11.25C5.03775 0 0 5.03775 0 11.25V24.75C0 30.9622 5.03775 36 11.25 36H24.75C30.9622 36 36 30.9622 36 24.75V11.25C36 5.03775 30.9622 0 24.75 0ZM32.625 24.75C32.625 29.0925 29.0925 32.625 24.75 32.625H11.25C6.9075 32.625 3.375 29.0925 3.375 24.75V11.25C3.375 6.9075 6.9075 3.375 11.25 3.375H24.75C29.0925 3.375 32.625 6.9075 32.625 11.25V24.75Z"
        fill={color}
      />
      <path
        d="M18 9C13.0297 9 9 13.0297 9 18C9 22.9703 13.0297 27 18 27C22.9703 27 27 22.9703 27 18C27 13.0297 22.9703 9 18 9ZM18 23.625C14.8995 23.625 12.375 21.1005 12.375 18C12.375 14.8973 14.8995 12.375 18 12.375C21.1005 12.375 23.625 14.8973 23.625 18C23.625 21.1005 21.1005 23.625 18 23.625Z"
        fill={color}
      />
      <path
        d="M27.6751 9.5235C28.3375 9.5235 28.8744 8.98657 28.8744 8.32425C28.8744 7.66191 28.3375 7.125 27.6751 7.125C27.0128 7.125 26.4758 7.66191 26.4758 8.32425C26.4758 8.98657 27.0128 9.5235 27.6751 9.5235Z"
        fill={color}
      />
    </Svg>
  )
}

export default Instagram
